const day = 1000 * 60 * 60 * 24;
const mn = "month";
const wk = "week";
const dy = "day";

/**
 * Calculate date difference in whole days.
 */
const daysMath = (ms: number) => {
    const now = new Date();
    return Math.abs(Math.ceil((ms - now.getTime()) / day));
};

const getTimeAgoString = (
    num: number,
    span: string
) => `${num}${num > 2 && span === mn ? "+" : ""} ${span}${num > 1 ? "s" : ""} ago`;

/**
 * Format a date in days, weeks months ago.
 */
const formatDateAsAge = (posted: string) => {
    const now = new Date();
    const midnightMs = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
    const postedDate = new Date(posted);
    const postedMs = new Date(postedDate.getFullYear(), postedDate.getMonth(), postedDate.getDate(), 0, 0, 0).getTime();

    switch (true) {
    case postedMs < midnightMs - (day * 90):
        return getTimeAgoString(3, mn);
    case postedMs < midnightMs - (day * 60):
        return getTimeAgoString(2, mn);
    case postedMs < midnightMs - (day * 28):
        return getTimeAgoString(1, mn);
    case postedMs < midnightMs - (day * 21):
        return getTimeAgoString(3, wk);
    case postedMs < midnightMs - (day * 14):
        return getTimeAgoString(2, wk);
    case postedMs < midnightMs - (day * 7):
        return getTimeAgoString(1, wk);
    case postedMs < midnightMs - day:
        return getTimeAgoString(daysMath(postedMs), dy);
    case postedMs < midnightMs:
        return "Yesterday";
    default:
        return "Today";
    }
};

export {
    formatDateAsAge
};
